export default __webpack_public_path__ + "static/media/carousel-3.50e6b4e1.jpg";